module.exports = __webpack_public_path__ + "img/b9_03.ce70e1cd.jpg";